import axios from 'src/clients/axios';
import {
  GetParentBalanceResponse,
  GetParentResponse,
  MULTI_ACCOUNT_MANAGEMENT_PARENT_BALANCE_URL,
  MULTI_ACCOUNT_MANAGEMENT_PARENT_URL,
} from 'src/models';

export const getParentBalance = () => {
  return axios.request<GetParentBalanceResponse>({
    method: 'get',
    url: MULTI_ACCOUNT_MANAGEMENT_PARENT_BALANCE_URL,
  });
};

export const getParent = (productionData = false) => {
  return axios.request<GetParentResponse>({
    method: 'get',
    url: MULTI_ACCOUNT_MANAGEMENT_PARENT_URL,
    onlyProduction: productionData,
  });
};
